import { gql } from "@apollo/client";
import { client } from "graphql/client";

export const GET_ACCOUNT_PICKUP_STAFF_BY_ACCOUNT_ID = gql`
    query GetAccountPickupStaffByAccountId($accountId: Long!) {
        getAccountPickupStaffByAccountId(accountId: $accountId) {
            id
            accountId
            warehouseId
        }
    }
`;

export interface AccountPickupStaffType {
    id: number;
    accountId: number;
    warehouseId: number;
}

export const getAccountPickupStaffByAccountId = async (accountId: number): Promise<AccountPickupStaffType> => {
    const { data } = await client.query({
        query: GET_ACCOUNT_PICKUP_STAFF_BY_ACCOUNT_ID,
        variables: { accountId }
    });
    return data.getAccountPickupStaffByAccountId;
};

